import { useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/api/query-keys";
import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Invalidate location-management queries after create/update mutations.
 */
export const useInvalidateMapQueries = () => {
	const queryClient = useQueryClient();
	const { selected } = useOrgSelection();
	const orgCode = selected?.orgCode ?? null;

	return () => {
		if (!orgCode) return;
		void queryClient.invalidateQueries({
			queryKey: queryKeys.locations.all(orgCode),
		});
		void queryClient.invalidateQueries({
			queryKey: queryKeys.installations(orgCode),
		});
	};
};
